import * as React from "react"
export const Svg_020 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={58}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M51.483 53.724v2.008H58v-6.517h-2.008a4.515 4.515 0 0 0-4.51 4.51Z"
    />
    <path
      fill="url(#b)"
      d="m48.084 13.305 1.927 1.926 2.403-2.403L46.385 6.8l-6.029 6.03 2.403 2.402 1.927-1.927-.003 7.21H30.696l.004-11.74 1.926 1.926 2.403-2.403L29 2.268l-6.029 6.029 2.403 2.403 1.928-1.927-.004 11.74H13.31l.003-7.208 1.927 1.926 2.403-2.403-6.03-6.029-6.028 6.029 2.403 2.403 1.927-1.927v9.217c0 4.36-3.548 7.908-7.908 7.908H0v15.387h2.008c4.36 0 7.908 3.548 7.908 7.908v2.008h38.168v-2.008c0-4.36 3.548-7.908 7.908-7.908H58V30.43h-2.008c-4.36 0-7.908-3.547-7.908-7.908v-9.216ZM17.048 39.822h-3.399v-3.398h3.399v3.398Zm11.303-3.398h1.297a5.18 5.18 0 0 1 5.175 5.174 5.183 5.183 0 0 1-4.124 5.067v2.27h-3.398v-2.2a4.733 4.733 0 0 1-4.124-4.688h3.398a1.33 1.33 0 0 0 1.328 1.327h1.746c.979 0 1.776-.797 1.776-1.776 0-.98-.797-1.776-1.776-1.776h-1.297a5.18 5.18 0 0 1-5.175-5.175A5.183 5.183 0 0 1 27.3 29.58v-2.27h3.398v2.201a4.733 4.733 0 0 1 4.124 4.688h-3.398a1.33 1.33 0 0 0-1.328-1.328h-1.746c-.979 0-1.776.797-1.776 1.776 0 .98.797 1.777 1.776 1.777Zm16 3.398h-3.399v-3.398h3.399v3.398Z"
    />
    <path
      fill="url(#c)"
      d="M55.992 27.03H58v-6.517h-6.517v2.008a4.515 4.515 0 0 0 4.51 4.51Z"
    />
    <path
      fill="url(#d)"
      d="M2.008 49.215H0v6.517h6.517v-2.008a4.515 4.515 0 0 0-4.51-4.51Z"
    />
    <path
      fill="url(#e)"
      d="M6.517 22.521v-2.008H0v6.518h2.008a4.515 4.515 0 0 0 4.51-4.51Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={52.99}
        x2={56.086}
        y1={50.192}
        y2={55.203}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={13.412}
        x2={37.836}
        y1={10.288}
        y2={53.169}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={52.99}
        x2={56.086}
        y1={21.491}
        y2={26.501}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={1.507}
        x2={4.603}
        y1={50.192}
        y2={55.203}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={1.507}
        x2={4.603}
        y1={21.491}
        y2={26.501}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)